import styled from 'styled-components';

export const PageLayoutStyled = styled.div`
  height: 100%;
`;
